module.exports = __webpack_public_path__ + "static/media/edg_logo.27020fc3.svg";